'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { Breadcrumbs } from '@mantine/core';
import { usePathname } from 'next/navigation';
export default function CommonBreadcrumbs(t0) {
  const $ = _c(6);
  const {
    items: t1,
    homeLabel: t2
  } = t0;
  const items = t1 === undefined ? [] : t1;
  const homeLabel = t2 === undefined ? "Home" : t2;
  const pathname = usePathname();
  if (!pathname) {
    return null;
  }
  const pathSegments = pathname.split("/").filter(Boolean);
  const autoItems = pathSegments.map((segment, index) => {
    const href = "/" + pathSegments.slice(0, index + 1).join("/");
    return {
      label: decodeURIComponent(segment.replace(/-/g, " ")),
      href
    };
  });
  const breadcrumbItems = items.length ? items : autoItems;
  breadcrumbItems.unshift({
    label: homeLabel,
    href: "/"
  });
  let t3;
  if ($[0] !== breadcrumbItems) {
    let t4;
    if ($[2] !== breadcrumbItems.length) {
      t4 = (item, index_0) => {
        const isLast = index_0 === breadcrumbItems.length - 1;
        return <span key={index_0} className="text-xs text-slate-900">{isLast ? <span className="font-medium capitalize">{item.label}</span> : <Link href={item.href} className="font-semibold capitalize">{item.label}</Link>}</span>;
      };
      $[2] = breadcrumbItems.length;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    t3 = breadcrumbItems.map(t4);
    $[0] = breadcrumbItems;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="ccrumb bg-blue-100 print:hidden"><div className="max-w-7xl mx-auto px-2"><Breadcrumbs separator="/" py="xs" separatorMargin="5px">{t3}</Breadcrumbs></div></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}